import { Component } from '@angular/core';

@Component({
	selector: 'ui-new-separator',
	template: ``,
	host: { class: 'bg-line-230 h-px block my-1' },
	standalone: true,
})
export class UiNewSeparatorComponent {}
